if($('footer#footer').length){
    $('#signature').append($('footer#footer .signatureLinks'));
    $(document).on('click', '.custom-footer>div h4', function(){
        $(this).closest('.custom-footer>div').toggleClass('openIt')
    });
    $('footer#footer ul.superContact').prepend($('footer#footer .contact-box li span.mail').closest('li'));
    $('footer#footer ul.superContact').prepend($('footer#footer .contact-box li span.tel').closest('li'));
    $('footer#footer').before($('footer#footer .reviews'));
    $('.custom-footer__newsletter').prepend($('footer#footer .newsletterNotice'));
    $('.footer-bottom #signature').append($('footer#footer .shopcodeSignature'));
    $('#formNewsletterWidget input[type="email"]').attr('placeholder', 'Váš e-mail');
}